import { createSlice } from "@reduxjs/toolkit";
import { getProducts, addNewProduct, updateProduct, deleteProduct } from "./thunk";

export const initialState = {
  products: [],
  error: {},
};

const ProductsSlice = createSlice({
  name: "ProductsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProducts.fulfilled, (state: any, action: any) => {
      state.products = action.payload;
    });
    builder.addCase(getProducts.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(addNewProduct.fulfilled, (state: any, action: any) => {
      state.products.push(action.payload);
    });
    builder.addCase(addNewProduct.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(updateProduct.fulfilled, (state: any, action: any) => {
      state.products = state.products.map((product: any) =>
        product.id === action.payload.id ? { ...product, ...action.payload } : product
      );
    });
    builder.addCase(updateProduct.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(deleteProduct.fulfilled, (state: any, action: any) => {
      state.products = state.products.filter(
        (product: any) => product.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteProduct.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
  },
});

export default ProductsSlice.reducer;
